import React, { FC, useEffect } from "react";

import { useTranslation } from "react-i18next";
import { useMount } from "react-use";

import { StandardLayout } from "@/components/layouts";
import { useGlobalFilter, useNavigation, usePolicyholders } from "@/shared/hooks";
import { useUserFeedback } from "@/userFeedback";

import FolderPanel from "./components/FolderPanel/FolderPanel";
import { StyledMyFilesSubTitle } from "./styled";
import { FolderType } from "./utils";

const PolicyholderPage: FC = () => {
    const { t } = useTranslation();
    const { isProEnvironment } = useGlobalFilter();
    const { getPolicyholders } = usePolicyholders();
    const { navToPolicyholderDetail } = useNavigation();

    const policyholders = getPolicyholders();
    const { incUsageCount } = useUserFeedback();

    useMount(incUsageCount);

    const handlePolicyholderClick = (policyholderId: number) => {
        navToPolicyholderDetail(policyholderId);
    };

    useEffect(() => {
        if (policyholders.length === 1 && policyholders[0].accessRights?.canViewInformationDetail === true) {
            handlePolicyholderClick(policyholders[0].policyHolderId);
        }
    }, [policyholders]);

    return (
        <StandardLayout title={t("PageTitles.MyFiles")}>
            <div className="header">
                <StyledMyFilesSubTitle>{t("MyFiles.General.SubTitle")}</StyledMyFilesSubTitle>
            </div>

            <FolderPanel
                dataTestId={isProEnvironment ? "companies_folder_items" : "particulars_folder_items"}
                policyholders={policyholders}
                type={isProEnvironment ? FolderType.COMPANY : FolderType.PARTICULAR}
                onPolicyholderClick={handlePolicyholderClick}
            />
        </StandardLayout>
    );
};

export default PolicyholderPage;
